export default "/assets/images/mila-feed-01-thumbnail.f8acf0e2cec5b2ff.jpg";